module.exports = __webpack_public_path__ + "img/dark-mud-decal-03.7790d24b.png";